import React from 'react';
import { Grid, Cell, Switch } from 'react-foundation';

import styled from 'styled-components';

const Row = styled(Grid)`
    margin-top: 10px;
`;

const SubHeadingRow = styled(Grid)`
    font-family: 'Arial';
    margin-top: 25px;
    font-weight: 600;
`;

const LeftCell = props => <Cell large={4} className="flex-container align-middle">{props.children}</Cell>;
const RightCell = props => <Cell large={8} className="flex-container align-middle">{props.children}</Cell>;

const MinSwitch = styled(Switch)`
    margin-bottom: 0px;
`;

const SwitchComponent = ({componentStateProperty, componentState, setState}) => {
  return (
    <Switch input={{
      checked: componentState,
      onChange: ()=>{}}}
            onChange={() => {
              const newState = {};
              newState[componentStateProperty] = !componentState;
              setState(newState)
            }
          } />
  )
};

export {
  Row,
  SubHeadingRow,
  LeftCell,
  RightCell,
  MinSwitch as Switch,
  SwitchComponent
};

